import { DropDownBox, DropDownBoxComponentSpacing } from './DropDownBox';
import UsaStates, { IStateResult } from 'usa-states';

interface StateDropDownProps {
    id: string;
    value: string | undefined;
    label: string;
    helperText?: string;
    required?: boolean;
    placeholder?: string;
    width?: string;
    readOnly?: boolean;
    onChange: (value: string) => void;
    validator?: React.ReactNode;
    onValidationEvent?: (isValid: boolean) => void;
    showInfoIcon?: boolean;
    infoText?: string;
    componentSpacing: DropDownBoxComponentSpacing;
}

export const StateDropDown: React.FC<StateDropDownProps> = ({
    id,
    value,
    label,
    helperText,
    required = false,
    placeholder,
    width,
    readOnly = false,
    onChange,
    validator,
    onValidationEvent,
    showInfoIcon = false,
    infoText,
    componentSpacing = DropDownBoxComponentSpacing.StandardSpacing,
}) => {
    const usaStates: IStateResult[] = new UsaStates.UsaStates().states;

    return (
        <DropDownBox
            id={id}
            value={value}
            onChange={onChange}
            label={label}
            helperText={helperText}
            required={required}
            dataSource={usaStates}
            placeholder={placeholder}
            width={width}
            valueExpr='abbreviation'
            displayExpr={width && parseInt(width) <= 100 ? 'abbreviation' : 'name'}
            readOnly={readOnly}
            validator={validator}
            onValidationEvent={onValidationEvent}
            showInfoIcon={showInfoIcon}
            infoText={infoText}
            componentSpacing={componentSpacing}
        />
    );
};
